module.exports = __webpack_public_path__ + "static/FCAC-Logo-b5585b8ca3958f8123921a62ed8491a5.png";